<template>
  <div class="cr-history">
    <div class="cr-container">
      <section class="cr-tabs">
        <div class="cr-tabs__button-wrapper">
          <ul class="cr-tabs__list">
            <li class="cr-tabs__item" @click="setTabActive('current')" ref="current" :class="{isActive: tabShow == 'current'}">
              <button class="cr-tabs__button js-button-tab"  type="button">
                Текущие
              </button>
            </li>
            <li class="cr-tabs__item"  @click="setTabActive('finish')" ref="finish" :class="{isActive: tabShow == 'finish'}">
              <button class="cr-tabs__button js-button-tab" type="button">
                Завершенные
              </button>
            </li>
            <li class="cr-tabs__glide" :style="tabGlide"></li>
          </ul>
        </div>
        <div class="cr-tabs__body-wrapper">
          <div class="cr-tabs__body isActive">
            <div v-if="ordersLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
            <div v-if="ordersError" class="mc-error">{{ ordersError }}</div>
            <div v-if="ordersLoaded" class="cr-history__section">
              <div v-if="false" class="cr-message cr-message--notification">
                Пожалуйста, оплатите просроченную дебиторскую задолженность
              </div>
              <div class="cr-filter">
                <form class="cr-filter__form cr-form" method="get" autocomplete="off">
                  <div class="cr-filter__top">
                    <div class="cr-filter__sorting">
                      <button @click="sortShow=true" class="cr-filter__button-sorting simulated-hover" type="button">
                        <svg width="20" height="20" viewBox="0 0 20 20">
                          <use xlink:href="/assets/img/svg/sprite.svg#icon-sorting"></use>
                        </svg>
                      </button>
                    </div>
                    <div class="cr-filter__filters">
                      <button @click="filterShow=true" class="cr-filter__button-filters simulated-hover" type="button">
                        Фильтры
                        <span v-if="countFilter > 0" class="cr-filter__button-label">
                                        {{ countFilter }}
                                    </span>
                      </button>
                    </div>
                    <button v-if="countFilter > 0" @click="setFilter(true);" class="cr-filter__button-reset" type="reset">
                      Сбросить фильтры
                      <svg width="14" height="14" viewBox="0 0 14 14">
                        <use xlink:href="/assets/img/svg/sprite.svg#icon-cross"></use>
                      </svg>
                    </button>
                  </div>
                </form>
              </div>
              <ul class="cr-history__list">
                <li v-for="item in orders" class="cr-history__item">
                  <div class="cr-order-card">
                    <div class="cr-order-card__top">
                      <div class="cr-order-card__header">
                        <div class="cr-order-card__number">
                          №{{ item.number }}
                        </div>
                        <ul class="cr-order-card__status-list">
                          <li class="cr-order-card__status-item">
                            {{ item.status }}
                          </li>
                          <li :class="'cr-order-card__status-item--'+(item.pay?'blue':'yellow')" class="cr-order-card__status-item">
                            {{item.pay?'Оплачен':'Не оплачен'}}
                          </li>
                        </ul>
                      </div>
                      <div class="cr-order-card__date">
                        {{ item.date_create }}
                      </div>
                      <div class="cr-order-card__address">
                        {{ item.address }}
                      </div>
                    </div>
                        <swiper
                            wrapperTag="ul"
                            :modules="modules"
                            :pagination="false"
                            spaceBetween="5"
                            class="cr-order-card__slider swiper"
                            wrapperClass="cr-order-card__slider-list swiper-wrapper">
                          <swiper-slide v-for="product in item.items" class="cr-order-card__slider-item swiper-slide" tag="li">
                          <img class="cr-order-card__slider-image" v-if="product.product" :src="product.product.picture" width="50" height="60" alt="">
                          </swiper-slide>
                        </swiper>
                    <div class="cr-order-card__bottom">
                      <div class="cr-order-card__sum">
                        {{ item.sum }} ₽
                      </div>
                      <router-link class="cr-order-card__link cr-link" :to="'/personal/order/'+item.id+'/'">
                        Подробнее
                      </router-link>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>

  <div class="cr-modal" :class="{isOpen: sortShow}" id="sortingModal">
    <div class="cr-modal__outer">
      <div class="cr-modal__inner">
        <div class="cr-modal__heading">
          <button @click="sortShow=false" class="cr-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
            <svg class="cr-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
              <use xlink:href="/assets/img/svg/sprite.svg#icon-cross-1"></use>
            </svg>
          </button>
          <div class="cr-modal__title">
            Сортировка
          </div>
        </div>
        <div class="cr-modal__body">
          <ul class="cr-form__options-list">
            <li v-for="item in sort" class="cr-form__options-item">
              <div class="cr-form__field">
                <input class="cr-form__radio" type="radio" v-model="sortCurrent" :id="'sorting'+item.id" :value="item.id" :checked="sortCurrent==item.id">
                <label @click="sortOrder(item.id)" class="cr-form__label simulated-hover" :for="'sorting'+item.id">
                  {{ item.name }}
                </label>
              </div>
            </li>
          </ul>
        </div>
        <div class="cr-modal__bottom">
          <button @click="sortShow=false" class="cr-button js-button-close" type="button">
                                                    <span class="cr-button__text">
                                                        Закрыть
                                                    </span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="cr-modal" :class="{isOpen: filterShow}" id="filters2Modal">
    <div class="cr-modal__outer">
      <div class="cr-modal__inner">
        <div class="cr-modal__heading">
          <span class="cr-modal__line"></span>
          <button @click="filterShow = false" class="cr-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
            <svg class="cr-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
              <use xlink:href="/assets/img/svg/sprite.svg#icon-cross-1"></use>
            </svg>
          </button>
          <div class="cr-modal__title">
            Фильтры
          </div>
        </div>
        <div class="cr-modal__body">
          <div class="cr-filter__body">
            <div class="cr-form__date-selection">

              <div class="cr-form__item-wrapper">
                <div class="cr-form__label">
                  Выберите квартал или введите другой период
                  <span class="cr-form__asterisk">
                                        *
                                    </span>
                </div>
                <div class="cr-scroll-row">
                  <ul class="cr-scroll-row__list">
                    <li v-for="quarter in quarters" :key="quarter.id" class="cr-scroll-row__item">
                      <div class="cr-form__field">
                        <input
                            class="cr-form__checkbox cr-form__checkbox--button-light"
                            type="radio"
                            :name="'quarter'"
                            :id="quarter.id"
                            :value="quarter.id"
                            v-model="selectedQuarter"
                            @change="selectQuarter(quarter)"
                        >
                        <label class="cr-form__label" :for="quarter.id">
                          {{ quarter.label }}
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="cr-form__item-wrapper cr-form__item-wrapper--col2">
                <div class="cr-form__field">
                  <div class="cr-form__label">
                    Начало
                  </div>
                  <div class="cr-form__date-wrapper">
                    <Datepicker
                        v-model="formData.from"
                        locale="ru-RU"
                        :max-date="formData.to"
                        format="dd.MM.yyyy"
                        class="cr-form__date"
                        auto-apply
                        :enable-time-picker="false"
                        placeholder="ДД.ММ.ГГГГ"
                    >
                      <template #input-icon></template>
                    </Datepicker>
                  </div>
                </div>
                <div class="cr-form__field">
                  <div class="cr-form__label">
                    Конец
                  </div>
                  <div class="cr-form__date-wrapper">
                    <Datepicker
                        v-model="formData.to"
                        locale="ru-RU"
                        format="dd.MM.yyyy"
                        :min-date="formData.from"
                        class="cr-form__date"
                        auto-apply
                        :enable-time-picker="false"
                        placeholder="ДД.ММ.ГГГГ"
                    >
                      <template #input-icon></template>
                    </Datepicker>
                  </div>
                </div>
              </div>

              <div v-if="false" class="cr-form__item-wrapper">
                <div class="cr-form__label">
                  Выберите квартал или введите другой период
                </div>
                <div class="cr-scroll-row">
                  <ul class="cr-scroll-row__list">
                    <li class="cr-scroll-row__item">
                      <div class="cr-form__field">
                        <input class="cr-form__checkbox cr-form__checkbox--button-light" type="checkbox" name="checkbox-1" id="checkbox-1">
                        <label class="cr-form__label" for="checkbox-1">
                          I 2025
                        </label>
                      </div>
                    </li>
                    <li class="cr-scroll-row__item">
                      <div class="cr-form__field">
                        <input class="cr-form__checkbox cr-form__checkbox--button-light" type="checkbox" name="checkbox-2" id="checkbox-2">
                        <label class="cr-form__label" for="checkbox-2">
                          IV 2024
                        </label>
                      </div>
                    </li>
                    <li class="cr-scroll-row__item">
                      <div class="cr-form__field">
                        <input class="cr-form__checkbox cr-form__checkbox--button-light" type="checkbox" name="checkbox-3" id="checkbox-3">
                        <label class="cr-form__label" for="checkbox-3">
                          III 2024
                        </label>
                      </div>
                    </li>
                    <li class="cr-scroll-row__item">
                      <div class="cr-form__field">
                        <input class="cr-form__checkbox cr-form__checkbox--button-light" type="checkbox" name="checkbox-4" id="checkbox-4">
                        <label class="cr-form__label" for="checkbox-4">
                          II 2024
                        </label>
                      </div>
                    </li>
                    <li class="cr-scroll-row__item">
                      <div class="cr-form__field">
                        <input class="cr-form__checkbox cr-form__checkbox--button-light" type="checkbox" name="checkbox-5" id="checkbox-5">
                        <label class="cr-form__label" for="checkbox-5">
                          I 2024
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div v-if="false" class="cr-form__item-wrapper cr-form__item-wrapper--col2">
                <div class="cr-form__field">
                  <div class="cr-form__label">
                    Начало
                  </div>
                  <div class="cr-form__date-wrapper">
                    <input class="cr-form__date" type="date" name="dateStart">
                  </div>
                </div>
                <div class="cr-form__field">
                  <div class="cr-form__label">
                    Конец
                  </div>
                  <div class="cr-form__date-wrapper">
                    <input class="cr-form__date" type="date" name="dateEnd">
                  </div>
                </div>
              </div>
            </div>
            <div v-if="tabShow !== 'finish'" class="cr-filter__section cr-filter-section">
              <div class="cr-filter-section__name">
                Статус
              </div>
              <div class="cr-filter-section__body">
                <ul class="cr-filter-section__list">
                  <li v-for="item in status" class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" v-model="formData.status" :value="item.id" :id="'status'+item.id">
                      <label class="cr-form__label simulated-hover" :for="'status'+item.id">
                        {{ item.name }}
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="cr-filter__section cr-filter-section">
              <div class="cr-filter-section__name">
                Адрес
              </div>
              <div class="cr-filter-section__body">
                <ul class="cr-filter-section__list">
                  <li v-for="item in address" class="cr-filter-section__item">
                    <div class="cr-form__field">
                      <input class="cr-form__checkbox cr-form__checkbox--button" type="checkbox" v-model="formData.address" :value="item.address" :id="'address'+item.id">
                      <label class="cr-form__label simulated-hover" :for="'address'+item.id">
                        {{ item.address }}
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="cr-modal__bottom">
          <button @click="setFilter(false)" class="cr-button js-button-close" type="submit">
                                                                    <span class="cr-button__text">
                                                                        Применить
                                                                    </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import num from "@/mixin/num.vue";
import tab from "@/mixin/tab.vue";
import queryString from "query-string";
import {mapActions, mapGetters} from "vuex";
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';
import { Pagination, Navigation, Scrollbar } from 'swiper';
import Datepicker from "@vuepic/vue-datepicker";
import '@vuepic/vue-datepicker/dist/main.css'

export default {
  data() {
    return {
      modules: [Pagination, Navigation, Scrollbar],
      dataFilter: {},
      sortShow: false,
      filterShow: false,
      loadingMore: false,
      currentPage: parseInt(this.$route.query.page) || 1,
      filterValues: [],
      sortCurrent: 'date',
      sort: [
        {
          id: 'date',
          name: 'По дате'
        },
        {
          id: 'price_asc',
          name: 'По возрастанию стоимости'
        },
        {
          id: 'price_desc',
          name: 'По убыванию стоимости'
        }
      ],
      propertyQuery: '',
      selectedQuarter: null,
      quarters: [],
      status: [],
      address: [],
      formData: {
        from: '',
        to: '',
        status: [],
        address: []
      },
    }
  },
  mixins: [num, tab],
  async created() {
    this.$nextTick(() => {
      this.setTabActive('current');
    });

    let filter = queryString.parse(window.location.search, {arrayFormat: 'index'});

    // Reset page if no products are loaded
    if (this.orders.length === 0) {
      this.currentPage = 1;
    }

    // Fetch initial data
    await this.fetchOrders({
      page: this.currentPage,
      sort: this.sortCurrent,
      filter: filter,
      first: true
    });
    this.quarters = this.filterItems.date;
    this.status = this.filterItems.status;
    this.address = this.filterItems.address;


    //this.updateFilterValues();

    // Add scroll event listener when component is created
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    // Remove scroll event listener when component is destroyed
    window.removeEventListener('scroll', this.handleScroll);
  },
  watch: {
    '$route.path'() {
      // Get search query and filter parameters
   /*   let filter = queryString.parse(window.location.search, {arrayFormat: 'index'});

      this.currentPage = 1;

      // Fetch new data for the changed route
      this.fetchOrders({
        page: this.currentPage,
        sort: this.sortCurrent,
        search: search,
        first: true
      });
*/
    },
    tabShow(value, oldValue) {
      if (oldValue) {
        let filter = {finish: value=='finish'};
        this.currentPage = 1;
        this.formData = {
              from: '',
              to: '',
              status: [],
              address: []
        };
        // Fetch initial data
        this.fetchOrders({
          page: this.currentPage,
          sort: this.sortCurrent,
          filter: filter,
          first: false
        });
      }
    },
    currentPage(newPage) {
      this.$router.replace({
        query: { ...this.$route.query, page: newPage }
      }, {
        force: true,
        shallow: true
      });
    },
    'formData.from'() {
      this.clearQuarterSelection()
    },
    'formData.to'() {
      this.clearQuarterSelection()
    }
  },
  computed: {
    ...mapGetters('orders', [
      'orders',
      'ordersLoading',
      'ordersError',
      'ordersLoaded',
      'order_total',
      'noMoreOrders',
      'filterItems',
        'countFilter'
    ]),
    filteredProperty() {
      return this.filterProperty();
    }
  },
  components: {
    Datepicker,
    Swiper,
    SwiperSlide
  },
  methods: {
    ...mapActions('orders', [
      'fetchOrders'
    ]),
    handleScroll() {
      if (this.$route.name != 'orders') {
        window.removeEventListener('scroll', this.handleScroll);
        return;
      }
      // Calculate if we've reached the bottom of the page
      const bottomOfWindow = Math.max(
          window.scrollY,
          document.documentElement.scrollTop,
          document.body.scrollTop
      ) + window.innerHeight >= document.documentElement.scrollHeight - 200;

      // If we are at the bottom of the page and not currently loading more orders
      if (bottomOfWindow && !this.loadingMore && this.ordersLoaded && !this.noMoreOrders) {
        this.loadMoreOrders();
      }
    },

    /**
     * Loads more orders when the user scrolls to the bottom of the page
     */
    async loadMoreOrders() {
      // Prevent multiple simultaneous loading requests
      if (this.loadingMore) {
        return;
      }

      try {
        this.loadingMore = true;

        // Calculate next page and prepare parameters
        const nextPage = this.currentPage + 1;
        let filter = queryString.parse(window.location.search, {arrayFormat: 'index'});

        filter.finish = this.tabShow==='finish';

        // Fetch next page of orders
        await this.fetchOrders({
          page: nextPage,
          sort: this.sortCurrent,
          filter: filter,
        });

        // Update current page only if fetch was successful
        this.currentPage++;
      } catch (error) {
        // Error is already handled in the store action
        console.error('Error loading more orders:', error);
      } finally {
        // Always reset loading state
        this.loadingMore = false;
      }
    },
    /**
     * Changes the sort order of orders
     * @param {string} sort - Sort parameter
     */
    sortOrder(sort) {
      // Update current sort
      this.sortCurrent = sort;

      // Get current filter and search parameters
      let filter = this.formData;
      filter.finish = this.tabShow==='finish';

      // Reset to page 1 and fetch orders with new sort
      this.currentPage = 1;
      this.fetchOrders({
        page: 1,
        sort: sort,
        filter: filter,
      });

      // Close sort modal after selection
      this.sortShow = false;
    },
    /**
     * Builds filter object from selected filter values
     * @returns {Object} Filter parameters object
     */
    getFilter() {
      const filter = {};

      // Return empty object if filters aren't available
      if (!this.filters || !Array.isArray(this.filters)) {
        return filter;
      }

      // Process each filter group
      this.filters.forEach(filterGroup => {
        if (!filterGroup.values || !filterGroup.code) {
          return; // Skip invalid filter groups
        }

        // Process each value in the filter group
        Object.values(filterGroup.values).forEach(value => {
          if (value.checked) {
            // Initialize array for this filter code if it doesn't exist
            if (!filter[filterGroup.code]) {
              filter[filterGroup.code] = [];
            }

            // Add the selected value ID to the filter
            if (value.id) {
              filter[filterGroup.code].push(value.id);
            }
          }
        });
      });

      return filter;
    },
    /**
     * Applies selected filters and fetches filtered orders
     */
    async setFilter(clear=false) {
      try {
        // Close filter modal
        this.filterShow = false;

        // Get current search query
        // Update URL with filter parameters
       /* this.$router.replace({
          query: { page: 1, ...this.dataFilter }
        }, {
          force: true,
          shallow: true
        });*/

        if (clear === true) {
          this.formData = {
              from: '',
              to: '',
              status: [],
              address: []
          };
        }

        let filter = this.formData;
        filter.finish = this.tabShow==='finish';

        // Reset to page 1 when applying filters
        this.currentPage = 1;

        // Fetch filtered orders
        this.fetchOrders({
          page: 1,
          sort: this.sortCurrent,
          filter: filter
        });

      } catch (error) {
        console.error('Error applying filters:', error);
      }
    },
    /**
     * Clears all values for a specific filter
     * @param {string|number} id - Filter ID
     */
    clearFilter(id) {
      // Return early if filter data isn't available
      if (!this.filter || !this.filter.ITEMS || !this.filter.ITEMS[id] || !this.filter.ITEMS[id].VALUES) {
        return;
      }

      // Uncheck all values in the filter
      Object.values(this.filter.ITEMS[id].VALUES).forEach(value => {
        if (value.CONTROL_NAME) {
          // Update UI state
          value.CHECKED = false;
          // Update data model
          this.dataFilter[value.CONTROL_NAME] = 'N';
        }
      });
    },

    /**
     * Toggles a filter value
     * @param {string} id - Control name of the filter
     */
    checkFilter(id) {
      if (!id) {
        return;
      }

      // Toggle between Y and N
      this.dataFilter[id] = this.dataFilter[id] === 'Y' ? 'N' : 'Y';
    },

    /**
     * Unchecks a filter and applies the changes
     * @param {string} id - Control name of the filter
     * @param {string} value - Value to set ('N' by default, 'unset' to remove)
     */
    uncheckFilter(id, value = 'N') {
      if (!id) {
        return;
      }

      // Either remove the filter or set it to the specified value
      if (value === 'unset') {
        delete this.dataFilter[id];
      } else {
        this.dataFilter[id] = value;
      }

      // Apply the filter changes
      this.setFilter();
    },
    /**
     * Updates local filter values based on server response
     */
    updateFilterValues() {
      // Reset filter data
      this.dataFilter = {};

      // Return early if filter data isn't available
      if (!this.filter || !this.filter.ITEMS) {
        return;
      }

      // Process each filter item
      Object.entries(this.filter.ITEMS).forEach(([key, item]) => {
        // Handle price range filters
        if (item.PRICE) {
          // Set minimum price if available
          if (item.VALUES?.MIN?.HTML_VALUE && item.VALUES?.MIN?.CONTROL_NAME) {
            this.dataFilter[item.VALUES.MIN.CONTROL_NAME] = item.VALUES.MIN.HTML_VALUE;
          }

          // Set maximum price if available
          if (item.VALUES?.MAX?.HTML_VALUE && item.VALUES?.MAX?.CONTROL_NAME) {
            this.dataFilter[item.VALUES.MAX.CONTROL_NAME] = item.VALUES.MAX.HTML_VALUE;
          }
        }
        // Handle other filter types
        else if (item.VALUES) {
          // Process each value in the filter
          Object.values(item.VALUES).forEach(value => {
            if (value.CHECKED && value.CONTROL_NAME) {
              this.dataFilter[value.CONTROL_NAME] = 'Y';
            }
          });
        }
      });
    },

    /**
     * Filters property values based on search query
     * @returns {Object} Filtered property object
     */
    filterProperty() {
      // If no search query, return all properties
      if (!this.propertyQuery || !this.filterPropertyAll) {
        return this.filterPropertyAll;
      }

      // Create a deep copy of the filter property object
      const result = JSON.parse(JSON.stringify(this.filterPropertyAll));

      // Convert search query to lowercase for case-insensitive comparison
      const searchQuery = this.propertyQuery.toLowerCase().trim();

      // Filter values that match the search query
      const filteredValues = Object.values(this.filterPropertyAll.VALUES || {}).filter(item =>
          item.VALUE && item.VALUE.toLowerCase().includes(searchQuery)
      );

      // Update the result with filtered values
      result.VALUES = filteredValues.length > 0 ? filteredValues : [];

      return result;
    },
    selectQuarter(quarter) {
      this.formData.from = new Date(quarter.start)
      this.formData.to = new Date(quarter.end)
    },
    clearQuarterSelection() {
      // Проверяем, было ли изменение ручным
      const isManualChange = !this.quarters.some(q =>
          this.isSameDate(new Date(q.start), this.formData.from) &&
          this.isSameDate(new Date(q.end), this.formData.to)
      )

      if (isManualChange) {
        this.selectedQuarter = null
      }
    },
    isSameDate(date1, date2) {
      if (!date1 || !date2) return false
      return date1.toISOString().split('T')[0] === new Date(date2).toISOString().split('T')[0]
    },
  },
}
</script>
